import React, { useContext, useEffect, useState } from 'react';
import CSVComp from './CSVComp'
import app from '../authentication/firebaseStart';
import styled from 'styled-components';
import { Button } from '@zebra-fed/zds-react-desktop';
import { useTranslation } from "react-i18next";
import DescriptionIcon from '@material-ui/icons/Description';
import CloseIcon from '@material-ui/icons/Close';
import { AuthContext } from '../authentication/Auth';
import LinearProgress from '@material-ui/core/LinearProgress';
import CProgress from '../components/CProgress';

const ButtonContainer = styled.div`
    display: flex;
    max-width: 500px;
    justify-content: end;
`;

const CloseIconCustom = styled(CloseIcon)`
    margin-right: 5px;
    &:hover {
        cursor: pointer;
    }
`;

const LinearProgressStyled = styled(LinearProgress)`
    width: 100%;
`;

const firestore = app.firestore();
var allApsData = [];
function CSVImport(props) {
    const { cancelClicked = () => { }, importType, ConfigData,
    //isLoadingCsv, sitesData, apsData, devicesData, hasUpdatedTime,
    refreshPage = () => { } } = props;
    const [importedRecords, setImportedRecords] = useState([])
    const [fileInfo, setFileInfo] = useState({})
    const [isParsed, setIsParsed] = useState(false)
    const [clearRecords, setClearRecords] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isLoading2, setIsLoading2] = useState(false)
    const [errorMsg, setErrorMsg] = useState("incorrect file")
    const [dataUpdated, setDataUpdated] = useState(false)
    const context = useContext(AuthContext);
    const [totalCsvParts, setTotalCsvParts] = useState(0);
    const [totalSiteCsvParts, setTotalSiteCsvParts] = useState(0);
    const [currPercent, setCurrPercent] = useState(0)
    const [currSiteLocPercent, setCurrSiteLocPercent] = useState(0)
    const { t } = useTranslation();
    const [matchedSiteFromAps, setMatchedSiteFromAps] = useState([])
    const [firebaseError, setFirebaseError] = useState(false)
    const [fireApsData, setFireApsData] = useState([])
    const [testApsData, setTestApsData] = useState([])
    const [hasUpdatedTime, setHasUpdatedTime] = useState(false);

    async function getInitialUpdatedTimeData() {
        let companyID = context.currentUser.claims.companyID;
        let data = (
          await firestore
            .collection("tenants")
            .doc(companyID)
            .collection("Configuration")
            .doc("UpdatedTime")
            .get()
        ).data();

        if (data) {
          setHasUpdatedTime(true);
        } else {
          setHasUpdatedTime(false);
        }
      }

      useEffect(() => {
        getInitialUpdatedTimeData();
      }, []);

    useEffect(() => { getInitialAccessData() }, [])

    async function getInitialAccessData() {
        let companyID = context.currentUser.claims.companyID;
        let devicesval = (
            await firestore
                .collection('tenants')
                .doc(companyID)
                .collection('Aps')
                .get()
        ).docs.map((doc) => doc.data());
        // console.log('devicesval :', devicesval);

        setFireApsData(devicesval)

    }

    useEffect(() => {
        if (dataUpdated) {
            setCurrPercent(0);
            setCurrSiteLocPercent(0)
        }
    }, [dataUpdated])


    function onImportDone(records, fileInfo) {
        setFileInfo(fileInfo);
    }

    function findPercentage(records, type) {
        let dataSplitLimit2 = 499;
        let convertedJson = records;
        const index = convertedJson.length;
        let count = 0;
        for (let i = 0; i < convertedJson.length; i++) {
            if ((i + 1) % dataSplitLimit2 === 0) {
                count = count + 1;
            }
        }
        if (!(index % dataSplitLimit2) == 0) {
            count = count + 1;
        }

        if (type === 'SITE') {
            setTotalSiteCsvParts(count);
        }
        else {
            setTotalCsvParts(count);
        }
    }

    async function importToFirestore(method) {
        let dataSplitLimit = 499;
        let convertedJson = importedRecords;
        try {
            let batch = firestore.batch();
            const index = convertedJson.length;
            var fakeIndex = 0;
            for (let i = 0; i < convertedJson.length; i++) {
                const doc = convertedJson[i];
                // YOUR UPDATES
                // await new Promise(r => setTimeout(r, 0.1));

                var accessRef = firestore.collection("tenants")
                    .doc(context.currentUser.claims.companyID)
                    .collection('Aps')
                    .doc(doc.BSSID.toUpperCase());

                let apsObj = {
                    "apMacAddress": doc.BSSID.toUpperCase(),
                    "displayApMacAddress": doc.BSSID,
                    "apAssetName": doc.AssetName,
                    "apFriendlyName": doc.LocationFriendlyName.toUpperCase(),
                    "displayAPFriendlyName": doc.LocationFriendlyName,
                    "siteName": doc.SiteName.toUpperCase(),
                    "displaySiteName": doc.SiteName,
                    "lastUpdatedAt": Date.now()
                }

                let findApsOld = testApsData.filter(values => values.apMacAddress === doc.BSSID.toUpperCase())
                let newStrAps = findApsOld[0];
                let ExistingApsObj;
                if (method === 'MODIFY') {
                    if (findApsOld.length > 0) {
                        newStrAps["apMacAddress"] = doc.BSSID.toUpperCase();
                        newStrAps["displayApMacAddress"] = doc.BSSID;
                        newStrAps["apAssetName"] = doc.AssetName;
                        newStrAps["apFriendlyName"] = doc.LocationFriendlyName.toUpperCase();
                        newStrAps["displayAPFriendlyName"] = doc.LocationFriendlyName;
                        newStrAps["siteName"] = doc.SiteName.toUpperCase();
                        newStrAps["displaySiteName"] = doc.SiteName;
                        newStrAps["lastUpdatedAt"] = Date.now();
                        ExistingApsObj = newStrAps
                    } else {
                        ExistingApsObj = apsObj
                    }
                }


                method === 'DELETE' ? batch.delete(accessRef)
                    : method === 'MODIFY' ?
                        batch.set(accessRef, ExistingApsObj)
                        :
                        batch.set(accessRef, apsObj);


                if ((i + 1) % dataSplitLimit === 0) {
                    fakeIndex = fakeIndex + 1;
                    setCurrPercent(Math.round((fakeIndex / totalCsvParts) * 100));
                    await batch.commit()
                    batch = firestore.batch();
                }
            }
            // For committing final batch
            if (!(index % dataSplitLimit) == 0) {
                fakeIndex = fakeIndex + 1;
                setCurrPercent(Math.round((fakeIndex / totalCsvParts) * 100));
                await batch.commit()
            }
            let companyID = context.currentUser.claims.companyID;
            try {
                if (hasUpdatedTime) {
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('Configuration')
                        .doc('UpdatedTime')
                        .update({
                            siteInfoUpdated: Date.now()
                        })
                } else {
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('Configuration')
                        .doc('UpdatedTime')
                        .set({
                            siteInfoUpdated: Date.now()
                        })
                }
            } catch (error) {
                console.log('error :', error);
                setFirebaseError(true)

            }
            if (matchedSiteFromAps.length > 0) {
                importToFirestoreSiteLocationsUpdate();
            } else {
                setIsLoading(false);
                setDataUpdated(true);
            }
        } catch (error) {
            console.log('error :', error);
            setFirebaseError(true)
        }

    }

    async function importToFirestoreSiteLocationsUpdate(method) {

        let dataSplitLimit = 499;

        let convertedJson = matchedSiteFromAps;
        try {
            let batch = firestore.batch();
            const index = convertedJson.length;
            var fakeIndex = 0; var ArrAllsites = [];
            let asites = (await firestore.collection("tenants")
                    .doc(context.currentUser.claims.companyID)
                    .collection('SiteLocations').get()).docs.map((doc) => doc.data())
            asites.forEach(function (arrayItem) {
                let s = arrayItem.siteName;
                ArrAllsites.push(s);
            });
            for (let i = 0; i < convertedJson.length; i++) {
                const sn = convertedJson[i];
                if(sn) {
                    let sitesRef = firestore.collection("tenants")
                    .doc(context.currentUser.claims.companyID)
                    .collection('SiteLocations')
                    .doc(sn.toUpperCase());
                    if(ArrAllsites.includes(sn)) {                    
                        batch.update(sitesRef, {
                            siteApsUpdated: Date.now()
                        });
                        if ((i + 1) % dataSplitLimit === 0) {
                            fakeIndex = fakeIndex + 1;
                            setCurrSiteLocPercent(Math.round((fakeIndex / totalSiteCsvParts) * 100));
                            await batch.commit()
                            batch = firestore.batch();
                        }
                    }
                }
            }
            // For committing final batch
            if (!(index % dataSplitLimit) == 0) {
                fakeIndex = fakeIndex + 1;
                setCurrSiteLocPercent(Math.round((fakeIndex / totalSiteCsvParts) * 100));
                await batch.commit()
            }
            let companyID = context.currentUser.claims.companyID;
            try {
                if (hasUpdatedTime) {
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('Configuration')
                        .doc('UpdatedTime')
                        .update({
                            siteInfoUpdated: Date.now()
                        })
                } else {
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('Configuration')
                        .doc('UpdatedTime')
                        .set({
                            siteInfoUpdated: Date.now()
                        })
                }
            } catch (error) {
                console.log('error :', error);
                setFirebaseError(true)
            }
            setIsLoading(false);
            setDataUpdated(true);
        } catch (error) {
            console.log('error :', error);
            setFirebaseError(true)
        }

    }

    function handleCancel(value) {
        value === 'DISMISS' && refreshPage();
        cancelClicked();
        setIsParsed(false)
        setClearRecords(true)
        setDataUpdated(false)
        setIsLoading(false)
        setIsLoading2(false)
        setImportedRecords([])
        setFirebaseError(false)
        getInitialAccessData();
        allApsData = [];
        setTestApsData([]);
    }

    const onClickContinueBtn = () => {
        setIsLoading(true);
        importToFirestore(importType?.value);
    }

    const onParsingStart = (value) => {
        if (value) {
            setIsLoading2(true)
        }
    }

    const getAllDataOnlyAps = async (lastReported, sitee) => {
        let companyID = context.currentUser.claims.companyID;

        if (sitee) {
            let Query;
            Query = firestore.collection("tenants")
                .doc(companyID)
                .collection('Aps')
                .where('siteName', '==', sitee.toUpperCase())
                .orderBy('apMacAddress', 'desc')

            if (lastReported != null) { Query = Query.startAfter(lastReported) }
            const snapshot = (await Query.limit(4000).get());
            let snapshotData = snapshot.docs.map((doc) => doc.data());
            allApsData = allApsData.concat(snapshotData)
            setTestApsData(allApsData)
            lastReported = snapshotData[snapshotData.length - 1]?.apMacAddress;
            if (snapshotData.length === 0) {
                setIsLoading2(false)
                return
            }
            getAllDataOnlyAps(lastReported)

        }

    }

    const onParsingComplete = (results, records, siteMatchedAps, siteMatchedDevices, SitesMatchedfromAps) => {
        let getSiteFromRecOld = [...new Set(records.map(val => val.SiteName))]
        let getSiteFromRec = [...new Set(records.map(val => val.SiteName))]
        getSiteFromRec.push("LAST_ELEM")
        getSiteFromRec.forEach((vva) => {
            getAllDataOnlyAps('lastReported', vva)
        })

        if (records?.length > 0) {
            setImportedRecords(records);
            if (importType?.page === 'APS') {
                setMatchedSiteFromAps(getSiteFromRecOld);
                findPercentage(records);
                findPercentage(getSiteFromRecOld, 'SITE');
            } else {
                findPercentage(records);

            }
        } else {
            setImportedRecords([])
        }
        setIsParsed(true)
        setClearRecords(false)
    }

    const onClickXButton = () => {
        setIsParsed(false)
        setClearRecords(true)
    }

    return (
        <div>
            <span style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                {
                    firebaseError ?
                        <p>Error Occured. Please retry</p>
                        :
                        isLoading ?
                            <span style={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <div style={{ display: 'flex', border: '2px solid gainsboro', alignItems: 'center', width: '230px', justifyContent: 'space-between', padding: '5px' }}>
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        <DescriptionIcon style={{ fontSize: '35px' }} />
                                        <span>
                                            <p style={{ margin: '0px', fontSize: '14px' }}>{fileInfo?.name?.length > 20 ? fileInfo?.name?.substring(0, 20) + ".." : fileInfo?.name}</p>
                                            <p style={{ margin: '0px', fontSize: '12px' }}>{fileInfo?.size}</p>
                                        </span>
                                    </span>
                                </div>
                                <CProgress percent={(Math.round(currPercent / 2) + (currSiteLocPercent / 2))} />
                            </span>
                            :
                            dataUpdated ?
                                <>
                                    {importType?.value === 'ADD' ?
                                        <p>AP data saved successfully to database</p>
                                        : importType?.value === 'MODIFY' ?
                                            <p>AP data modified successfully in database</p>
                                            : <p>AP data deleted successfully from database</p>
                                    }
                                </>
                                :
                                !isLoading2 && importedRecords.length > 0 && isParsed ?
                                    <div style={{ display: 'flex', border: '2px solid gainsboro', alignItems: 'center', width: '230px', justifyContent: 'space-between', padding: '5px' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                            <DescriptionIcon style={{ fontSize: '35px' }} />
                                            <span>
                                                <p style={{ margin: '0px', fontSize: '14px' }}>{fileInfo?.name?.length > 20 ? fileInfo?.name?.substring(0, 20) + ".." : fileInfo?.name}</p>
                                                <p style={{ margin: '0px', fontSize: '12px' }}>{fileInfo?.size}</p>
                                            </span>
                                        </span>
                                        <CloseIconCustom onClick={onClickXButton} />

                                    </div>
                                    :

                                    <CSVComp
                                        onImportDone={onImportDone}
                                        onParsingComplete={onParsingComplete}
                                        onParsingStart={onParsingStart}
                                        clearRecords={clearRecords}
                                        errorMsg={errorMsg}
                                        isLoading2={isLoading2}
                                        ConfigData={ConfigData}
                                        //sitesData={sitesData}
                                        //apsData={apsData}
                                        //devicesData={devicesData}
                                        importType={importType}
                                        setIsLoading2 = {setIsLoading2}
                                        //isLoadingCsv={isLoadingCsv}
                                    />

                }

            </span>

            <ButtonContainer>
                {
                    firebaseError ?
                        <Button
                            onClick={() => handleCancel('DISMISS')}
                            type="primary"
                            style={{ marginLeft: '0px' }}
                        >
                            {t('dismiss')}
                        </Button>
                        :
                        dataUpdated ?
                            <Button
                                onClick={() => handleCancel('DISMISS')}
                                type="primary"
                                style={{ marginLeft: '0px' }}
                                disabled={!importedRecords.length > 0}
                            >
                                {t('dismiss')}
                            </Button>
                            :
                            <>
                                {
                                    //!isLoadingCsv &&
                                    <>
                                        <Button
                                            onClick={() => handleCancel()}
                                            type="primary"
                                            style={{ marginLeft: '0px', background: 'white', color: 'black', border: '2px solid gray' }}
                                        >
                                            {t('cancel')}
                                        </Button>
                                        <Button
                                            onClick={() => onClickContinueBtn()}
                                            type="primary"
                                            style={{ marginLeft: '0px' }}
                                            disabled={!importedRecords.length > 0 || isLoading}
                                        >
                                            {t('import')}
                                        </Button>
                                    </>
                                }
                            </>

                }
            </ButtonContainer>
        </div>
    )
}

export default CSVImport;